// extracted by mini-css-extract-plugin
export default {"root":"NumberInput_root__a8UCP","increment":"NumberInput_increment__j6HSr","input":"NumberInput_input__VlQBf"};